import React, { FC, useState, useEffect, useContext } from 'react'
import history from '../../history'
import { useLocation } from 'react-router-dom'
import { isMobile, isTablet, isBrowser } from 'react-device-detect'
import { Modal } from 'react-responsive-modal'
import platform from 'platform'

import AppContext from '../../context/appContext'
import { getUserData } from '../../Api/backendApi'

import {
  NavigationBarBox,
  NavigationItem,
  NavigationItemsBox,
} from './style/NavigationBarStyle'
import { SwitchContainer } from '../Challenges/style'

import DietDemoModeNotification from './views/DietDemoModeNotification'

import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericIcon from '../../GenericComponents/GenericIcon'

import BackButtonIcon from '../../assets/REDESIGN_Assets/NavigationBar/back-arrow.png'
import TrainingIcon from '../../assets/REDESIGN_Assets/NavigationBar/training-icon.png'
import PlanIcon from '../../assets/REDESIGN_Assets/NavigationBar/plan-icon.png'
import ProgressIcon from '../../assets/REDESIGN_Assets/NavigationBar/progress-icon.png'
import DietIcon from '../../assets/REDESIGN_Assets/NavigationBar/diet-icon.png'
import ProfileIcon from '../../assets/REDESIGN_Assets/NavigationBar/profile-icon.png'
import ThemeSwitchLight from '../../assets/REDESIGN_Assets/NavigationBar/theme-switch-light.png'
import ThemeSwitchDark from '../../assets/REDESIGN_Assets/NavigationBar/theme-switch-dark.png'
import ConferencesIcon from '../../assets/REDESIGN_Assets/NavigationBar/conferences-icon.svg'

interface NavigationBarInterface {
  backButtonAction: Function | null | undefined
  isPlayerView: boolean
  disableBackButton?: boolean
}

export const modalStyles = {
  closeButton: {
    display: 'none',
  },
  modal: {
    maxWidth: 'unset',
    width: isMobile ? '95vw' : '55vw',
    overflow: 'unset',
    left: '0',
    boxsizing: 'border-box',
    margin: isMobile ? 'auto' : 'unset',
    borderRadius: '30px',
  },
}

const NavigationBar: FC<NavigationBarInterface> = ({
  isPlayerView,
  backButtonAction,
  disableBackButton,
}) => {
  let location = useLocation()
  const appContext = useContext(AppContext)

  const [user, setUser] = useState(Object)
  const [isDemoMode, setDemoMode] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState('')

  useEffect(() => {
    obtainUser()
  }, [])

  useEffect(() => {
    if (user && user.id) {
      if (!user.has_subscription) setDemoMode(true)
    }
  }, [user])

  const navigate = (destination: string) => {
    appContext.updateAppState('location', destination)
    history.push(`${destination}`)
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    } else {
      const user = await getUserData()
      setUser(user)
      appContext.updateAppState('user', user)
    }
  }

  const changeTheme = () => {
    if (appContext && appContext.appState.theme == 'light') {
      appContext.updateAppState('theme', 'dark')
    } else {
      appContext.updateAppState('theme', 'light')
    }
  }

  const setUnallowedAccessModalOpen = (mode: string) => {
    switch (mode) {
      case 'dieta':
        setModalMode('Panel diet')
        setModalOpen(true)

        break

      case 'wspolne':
        setModalMode('Treningi wspolne')
        setModalOpen(true)
        break

      default:
        break
    }
  }

  const switchToChallenge = () => {
    history.push('/wyzwania')
  }

  return (
    <NavigationBarBox
      className={`${isPlayerView && 'player-view'} ${
        isTablet && 'tablet-view'
      } ${isBrowser && 'browser-view'}`}
    >
      {/* <SwitchContainer className="main-version-switch">
        <GenericTextSpan margin="0 5px 0 0">Pełna wersja MIAZGI</GenericTextSpan>
        <label className="switch full">
          <input onChange={switchToChallenge} type="checkbox" />
          <span className="slider round"></span>
        </label>
        <GenericTextSpan margin="0 0 0 5px">Wyzwania</GenericTextSpan>
      </SwitchContainer> */}
      {!isMobile && !disableBackButton && (
        <NavigationItemsBox className="left-side">
          {(location && location.pathname == '/trening') || isMobile ? null : (
            <NavigationItem onClick={backButtonAction}>
              <GenericIcon
                width={isMobile ? '7vw' : '1.5vw'}
                height={isMobile ? '7vw' : '1.5vw'}
                src={BackButtonIcon}
                className="navbar-icon"
              ></GenericIcon>
              <GenericTextSpan margin={' 10px 0 0 0 '} fSize={'0.8rem'}>
                Wróć
              </GenericTextSpan>
            </NavigationItem>
          )}
        </NavigationItemsBox>
      )}

      <NavigationItemsBox className="right-side">
        <NavigationItem
          className={`${location.pathname.includes('/trening') && 'active'} ${
            !isMobile && 'middle-icon'
          }`}
          onClick={() => navigate('/trening')}
        >
          <GenericIcon
            width={isMobile ? '7vw' : '1.5vw'}
            height={isMobile ? '7vw' : '1.5vw'}
            src={TrainingIcon}
            className="navbar-icon"
          ></GenericIcon>
          {!isMobile && (
            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Treningi
            </GenericTextSpan>
          )}
        </NavigationItem>

        {!isMobile && platform.name !== 'Safari' && (
          <NavigationItem
            className={`${
              location.pathname.includes('/treningi-wspolne') && 'active'
            } ${!isMobile && 'middle-icon'} ${isDemoMode ? 'blurred' : ''}`}
            onClick={() =>
              !isDemoMode
                ? navigate('/treningi-wspolne')
                : setUnallowedAccessModalOpen('wspolne')
            }
          >
            <GenericIcon
              width={isMobile ? '7vw' : '1.5vw'}
              height={isMobile ? '7vw' : '1.5vw'}
              className="navbar-icon"
              src={ConferencesIcon}
            ></GenericIcon>

            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Wspólne
            </GenericTextSpan>
          </NavigationItem>
        )}

        <NavigationItem
          className={`${
            location.pathname.includes('/plan-treningowy') && 'active'
          } ${!isMobile && 'middle-icon'}`}
          onClick={() => navigate('/plan-treningowy')}
        >
          <GenericIcon
            width={isMobile ? '7vw' : '1.5vw'}
            height={isMobile ? '7vw' : '1.5vw'}
            className="navbar-icon"
            src={PlanIcon}
          ></GenericIcon>
          {!isMobile && (
            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Plan
            </GenericTextSpan>
          )}
        </NavigationItem>

        <NavigationItem
          className={`${
            location.pathname.includes('/postepy') && 'active'
          } middle-icon`}
          onClick={() => navigate('/postepy')}
        >
          <GenericIcon
            width={isMobile ? '7vw' : '1.5vw'}
            height={isMobile ? '7vw' : '1.5vw'}
            className="navbar-icon"
            src={ProgressIcon}
          ></GenericIcon>
          {!isMobile && (
            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Postępy
            </GenericTextSpan>
          )}
        </NavigationItem>

        <NavigationItem
          className={`${
            location.pathname.includes('/dieta') && 'active'
          } middle-icon ${user && !user.diet_panel_access ? 'blurred' : ''}`}
          onClick={() =>
            user && user.diet_panel_access
              ? navigate('/dieta')
              : setUnallowedAccessModalOpen('dieta')
          }
        >
          <GenericIcon
            width={isMobile ? '7vw' : '1.5vw'}
            height={isMobile ? '7vw' : '1.5vw'}
            className="navbar-icon"
            src={DietIcon}
          ></GenericIcon>
          {!isMobile && (
            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Dieta
            </GenericTextSpan>
          )}
        </NavigationItem>

        <NavigationItem
          className={`${
            location.pathname.includes('/twoj-profil') && 'active'
          } middle-icon`}
          onClick={() => navigate('/twoj-profil')}
        >
          <GenericIcon
            width={isMobile ? '7vw' : '1.5vw'}
            height={isMobile ? '7vw' : '1.5vw'}
            className="navbar-icon"
            src={ProfileIcon}
          ></GenericIcon>
          {!isMobile && (
            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Profil
            </GenericTextSpan>
          )}
        </NavigationItem>
      </NavigationItemsBox>

      {!isMobile && (
        <NavigationItemsBox>
          <NavigationItem onClick={() => changeTheme()} className={'active'}>
            <GenericIcon
              width={'1.5vw'}
              height={'1.5vw'}
              src={ThemeSwitchDark}
            ></GenericIcon>
            <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
              Tryb
            </GenericTextSpan>
          </NavigationItem>
        </NavigationItemsBox>
      )}

      <Modal
        open={isModalOpen}
        animationDuration={700}
        onClose={() => setModalOpen(false)}
        center
        styles={modalStyles}
      >
        <DietDemoModeNotification
          closeModal={() => setModalOpen(false)}
          goToSub={() => history.push('/wybierz-plan/sub')}
          modalMode={modalMode}
        />
      </Modal>
    </NavigationBarBox>
  )
}

export default NavigationBar
